import { useQuery } from '@hooks/reactQuery';

import { getAssetsCommonValuesSystemFields } from '@api/assets';

import { refetchOptions } from '@constants/common';
import { ASSETS_LIST_DROPDOWN } from '@constants/queryKeys';

export const useQueryAssetsGroupSystemFields = () => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [ASSETS_LIST_DROPDOWN],
		queryFn: getAssetsCommonValuesSystemFields,
		...refetchOptions,
	});

	return {
		systemFields: data || [],
		isLoading: isInitialLoading,
	};
};
